import axios from "axios";

const API_URL = `${process.env.REACT_APP_API_ENDPOINT}/api/category`;

class CategoryService {
    getAll() {
        return axios.get(`${API_URL}/all`, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')?.trim()}`
            }
        });
    }
    getFilter(search) {
        return axios.get(`${API_URL}/getFilter`, {
            params: {
                search: search,
            },
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')?.trim()}`
            }
        });
    }
    getRootAll() {
        return axios.get(`${API_URL}/rootAll`, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')?.trim()}`
            }
        });
    }
    getChildrenAll(categoryId) {
        return axios.get(`${API_URL}/childrenAll`, {
            params: {
                categoryId: categoryId,
            },
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')?.trim()}`
            }
        });
    }
    getMaterialsAll(categoryId) {
        return axios.get(`${API_URL}/materialsAll`, {
            params: {
                categoryId: categoryId,
            },
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')?.trim()}`
            }
        });
    }
    add(category) {
        return axios.post(`${API_URL}/new`, category, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')?.trim()}`
            }
        });
    }
    update(category) {
        return axios.put(`${API_URL}/update`, category, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')?.trim()}`
            }
        });
    }
}

export default new CategoryService();
